var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5839 19.4795V28.0747C32.5839 29.6889 31.2894 30.9834 29.6752 30.9834H3.49657C1.89693 30.9834 0.587891 29.6889 0.587891 28.0747V19.4795C0.587891 17.8652 1.89686 16.5708 3.49657 16.5708C5.11079 16.5708 6.40525 17.8652 6.40525 19.4795V25.1659H26.7661V19.4795C26.7661 17.8652 28.0751 16.5708 29.6748 16.5708C31.2892 16.5708 32.5837 17.865 32.5837 19.4795H32.5839Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.385 11.8783L17.6125 19.9701C17.0836 20.6101 16.0881 20.6101 15.5595 19.9701L8.78725 11.8783C8.45387 11.4783 8.37408 10.9184 8.60062 10.4519C8.81376 9.98515 9.29388 9.67856 9.80053 9.67856H12.32V1.33325C12.32 0.600063 12.9067 0 13.6532 0H19.5057C20.2522 0 20.8389 0.599806 20.8389 1.33325V9.67928H23.3721C23.8918 9.67928 24.3585 9.98588 24.572 10.4526C24.7985 10.9188 24.7184 11.4787 24.3851 11.8788L24.385 11.8783Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadicon);
export default __webpack_public_path__ + "static/media/downloadicon.10b87016754d86ae387be803bda10ab3.svg";
export { ForwardRef as ReactComponent };